/**
 * TraceDocument → TrajectoryTurn mapping — the one place the generated API
 * shape meets the transcript model. Shared by the review page and the
 * trace-key transcript view (TRA-939 follow-up), so the two can't drift.
 */

import type { TraceDocument } from '@/api/generated/model'

import type { TrajectoryTurn } from './transcript'

export function docToTurn(doc: TraceDocument): TrajectoryTurn {
  return {
    traceId: doc.traceId,
    traceKey: doc.traceKey ?? null,
    requestBody: doc.request.bodyText ?? null,
    responseBody: doc.response.bodyText ?? null,
    latencyMs: doc.latencyMs,
    promptTokens: doc.tokenUsage ? doc.tokenUsage.promptTokens : null,
    completionTokens: doc.tokenUsage ? doc.tokenUsage.completionTokens : null,
    model: doc.requestModel ?? null,
    statusCode: doc.statusCode,
    requestDelta: doc.requestDelta ?? null,
    historyEdited: doc.historyEdited === true,
    timestamp: doc.timestamp,
  }
}
